import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";
import PDFViewerImage6 from "../../../../assets/PDFViewerImages/PDFViewerImage6.jpg";
import PDFViewerImage7 from "../../../../assets/PDFViewerImages/PDFViewerImage7.jpg";
import PDFViewerImage8 from "../../../../assets/PDFViewerImages/PDFViewerImage8.jpg";
import PDFViewerImage9 from "../../../../assets/PDFViewerImages/PDFViewerImage9.jpg";
import PDFViewerImage10 from "../../../../assets/PDFViewerImages/PDFViewerImage10.jpg";
import PDFViewerImage11 from "../../../../assets/PDFViewerImages/PDFViewerImage11.jpg";

const Chapter12 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);
    return (
        <>

             {/* Chapter 12 */}
                <section id="section12" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">
                       {language.chapter12Title}
                    </h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter12Paragraph1}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter12Paragraph2}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter12Paragraph3}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter12Paragraph4}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage6} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage7} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter12Paragraph5}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter12Paragraph6}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter12Paragraph7}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter12Paragraph8}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        ඉ{language.chapter12Paragraph9}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter12Paragraph10}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage8} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage9} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage10} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage11} alt="Traffic Rules"/>
                    </div>


                </section>
        </>
    )

}

export default Chapter12;
